export default "__VITE_ASSET__BPmXqkH6__"